<template>
	<div class="body-container" id="h-box">
		<Header :headerMini="headerMini" v-if="!headerMini"></Header>
		<div id="maincontent" class="main insights filter-page page-insight" rel="main">
			<div class="container">
				<div class="page-header-options">
					<div class="page-header-breadcrumb">
						<div class="breadcrumb-nav breadcrumb-nav-composed">
							<ul class="nav-links">
								<li class="nav-link" @click="goHome">
									<a ><span class="iconfont icon-shouye"></span></a>
								</li>
								<li class="nav-link">
									<span class="iconfont icon-xiangyou1"></span>
								</li>
								<li class="nav-link">
									<span>Insight</span>
								</li>
							</ul>

						</div>
					</div>
				</div>
				<div class="topic-selector" :style="{backgroundImage: 'url('+ topicBgList[toppicIndex] +')'}">
					<div class="topic-selector__background">
				
					</div>
					<div class="topic-selector__tiles--four-grid">
						<div class="topic-selector__header" @mouseover="changeTopicBg(0)">
							<div class="topic-selector__tile">Trending Content</div>
						</div>
						<div class="topic-selector__header topic-card-inner" @mouseover="changeTopicBg(1)">
							<div class="topic-selector__title">The Year Ahead Global Disputes Forecast 2024</div>
							<div class="topic-selector__card">
								<div class="topic-selector__card-inner">
									<div class="topic-selector__card-title">The Year Ahead Global Disputes Forecast 2024</div>
									<div class="topic-selector__card-content">Our seventh annual report provides detailed
										analysis of disputes trends, as well as sectoral and region-specific developments, to
										prepare your organization for The Year Ahead.</div>
									<div class="topic-selector__card-link">
										<span class="link--bold link--bold-white">Learn More&nbsp;</span>
									</div>
								</div>
							</div>
						</div>
						<div class="topic-selector__header topic-card-inner" @mouseover="changeTopicBg(2)">
							<div class="topic-selector__title">FT Due Diligence Series</div>
							<div class="topic-selector__card">
								<div class="topic-selector__card-inner">
									<div class="topic-selector__card-title">FT Due Diligence Series</div>
									<div class="topic-selector__card-content">Our lawyers are joined by industry thought leaders
										to discuss the key developments and issues shaping the future of global transactions.
									</div>
									<div class="topic-selector__card-link">
										<span class="link--bold link--bold-white">Learn More&nbsp;</span>
									</div>
								</div>
							</div>
						</div>
						<div class="topic-selector__header topic-card-inner" @mouseover="changeTopicBg(3)">
							<div class="topic-selector__title">Workforce Redesign: Outlooks for Business Leaders</div>
							<div class="topic-selector__card">
								<div class="topic-selector__card-inner">
									<div class="topic-selector__card-title">Workforce Redesign: Outlooks for Business Leaders
									</div>
									<div class="topic-selector__card-content">Explore the biggest factors shaping your
										workforce.</div>
									<div class="topic-selector__card-link">
										<span class="link--bold link--bold-white">Read More&nbsp;</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="global-module-page-wrapper global-module">

					<div class="featured-insights global-module">
						<div class="global-module-wrapper">
							<div class="section-header-wrapper">
								<h2 class="section-header">Featured Insight</h2>
							</div>
							<div class="featured-insights__collection ">
								<div class="featured-insights__tile promo-content-tile">
									<span class="promo-content-link promo-content-link--no-link promo-content-link__intro">
										<h2>InsightPlus</h2>
										<p>Our dedicated knowledge site offers up-to-date information on the current
											legal and regulatory matters impacting your business. Search by country,
											industry and area of legal practice.</p>
										<p><a rel="noopener noreferrer" target="_blank"><button class="button-red">Visit Site</button></a></p>
									</span>
								</div>
								<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image ">
									<a class="promo-content-link" target="_blank">

										<div class="container-table">

											<div class="pcm-standard-background-image c-bg1">
											</div>

											<div class="container-row ">
												<div class="content">
													<div class="content-meta-header">
														<div class="content-type-label content-type-label--with-right">

															Insight Thought | Leadership
														</div>

														<div class="content-meta-header__right">
															<div class="content-external-icon bm bm-external-link">
															</div>
														</div>
													</div>

													<div class="content-headline">6 Best Ways To Wreck Your Cross-Border
														Acquisition</div>
													<div class="content-summary">We’ve identified six ways large
														cross-border acquisitions can veer off course and provided a few
														suggestions for keeping them on track through to completion and
														integration.</div>
												</div>
											</div>
										</div>

									</a>

								</div>


								<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image ">
									<a class="promo-content-link">



										<div class="container-table">

											<div class="pcm-standard-background-image c-bg2">
											</div>

											<div class="container-row ">
												<div class="content">
													<div class="content-meta-header">
														<div class="content-type-label ">

															Insight | Thought Leadership
														</div>

													</div>

													<div class="content-headline">Unlocking and Accelerating Growth:
														Healthcare and Life Sciences in Asia Pacific</div>
													<div class="content-summary">Healthcare and life sciences
														breakthroughs offer opportunities to meet patient needs and
														create value, but rising costs and market uncertainty also apply
														significant pressure to operations.</div>
												</div>
											</div>
										</div>

									</a>

								</div>
							</div>
						</div>
					</div>

				</div>
				<!-- /ko -->
				<div>
					<!-- ko with: SearchFilters -->
					<div class="promo-content-category-switcher">
						<a class="switch default-cat selected cat-option-left c-switch" >Publications</a>

						<a class="switch default-cat cat-option-right c-switch">Events</a>
					</div>
					<!-- /ko -->
					<!-- ko if: IsListView() != true -->
					<div class="featured-insights">
						<div class="featured-insights__collection">
							<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="pcm-standard-background-image c-bg3">
										</div>
										<div class="container-row">
											<div class="content">
												<div class="content-type-label"
													data-bind="visible: TypeLabel, html: TypeLabel">Insight | Thought
													Leadership</div>
												<div class="content-headline" data-bind="html: Title, visible: Title">
													Unlocking and Accelerating Growth: Healthcare and Life Sciences in
													Asia Pacific</div>
												<div class="content-summary"
													data-bind="html: Summary, visible: Summary">Healthcare and life
													sciences breakthroughs offer opportunities to meet patient needs and
													create value, but rising costs and market uncertainty also apply
													significant pressure to operations.</div>
											</div>
										</div>
									</div>
								</a>
							</div>

							<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="pcm-standard-background-image c-bg4">
										</div>
										<div class="container-row">
											<div class="content">
												<div class="content-type-label"
													data-bind="visible: TypeLabel, html: TypeLabel">Insight | Handbook
												</div>
												<div class="content-headline" data-bind="html: Title, visible: Title">
													FCA Sustainability Disclosure Regime</div>
												<div class="content-summary"
													data-bind="html: Summary, visible: Summary">A practical overview of
													the regime and key points for firms to consider when launching an
													SDR labelled fund and completing entity-level disclosures.</div>
											</div>
										</div>
									</div>
								</a>
							</div>

							<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="pcm-standard-background-image c-bg5">
										</div>
										<div class="container-row">
											<div class="content">
												<div class="content-type-label"
													data-bind="visible: TypeLabel, html: TypeLabel">Insight | Thought
													Leadership</div>
												<div class="content-headline" data-bind="html: Title, visible: Title">
													The Next Decade in Fintech</div>
												<div class="content-summary"
													data-bind="html: Summary, visible: Summary">The financial sector has
													exemplified the massive benefits that come from embracing innovation
													and digital disruption, but staying on the cutting edge of progress
													demands constant evolution.</div>
											</div>
										</div>
									</div>
								</a>
							</div>

							<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="pcm-standard-background-image c-bg6">
										</div>
										<div class="container-row">
											<div class="content">
												<div class="content-type-label"
													data-bind="visible: TypeLabel, html: TypeLabel">Insight | Thought
													Leadership</div>
												<div class="content-headline" data-bind="html: Title, visible: Title">
													Fintech and Financial Stability</div>
												<div class="content-summary"
													data-bind="html: Summary, visible: Summary">Weighing the
													interconnected risks technology poses to financial systems.</div>
											</div>
										</div>
									</div>
								</a>
							</div>

							<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="pcm-standard-background-image c-bg7">
										</div>
										<div class="container-row">
											<div class="content">
												<div class="content-type-label"
													data-bind="visible: TypeLabel, html: TypeLabel">Insight | Handbook
												</div>
												<div class="content-headline" data-bind="html: Title, visible: Title">
													Private Wealth Newsletter - First Edition 2024</div>
												<div class="content-summary"
													data-bind="html: Summary, visible: Summary">The first edition of our
													Global Wealth Management Practice Group's Private Wealth Newsletter
													2024.</div>
											</div>
										</div>
									</div>
								</a>
							</div>

							<div class="featured-insights__tile promo-content-tile promo-content-tile--has-image">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="pcm-standard-background-image c-bg8">
										</div>
										<div class="container-row">
											<div class="content">
												<div class="content-type-label"
													data-bind="visible: TypeLabel, html: TypeLabel">Insight</div>
												<div class="content-headline" data-bind="html: Title, visible: Title">
													CS3D Explainer Series: What Does it Mean for Businesses?</div>
												<div class="content-summary"
													data-bind="html: Summary, visible: Summary">Our explainer series
													covers the most important aspects of the new EU Corporate
													Sustainability Reporting Directive.</div>
											</div>
										</div>
									</div>
								</a>
							</div>

							<div class="featured-insights__tile promo-content-tile promo-content-tile--no-image">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="pcm-standard-background-image" style="background: url(&quot;&quot;) 0% 0% / cover no-repeat; display: none;">
										</div>
										<div class="container-row">
											<div class="content">
												<div class="content-type-label"
													data-bind="visible: TypeLabel, html: TypeLabel">Insight | Legal
													Update</div>
												<div class="content-headline" data-bind="html: Title, visible: Title">
													The Employer Report: Navigating US and Global Employment Law</div>
												<div class="content-summary"
													data-bind="html: Summary, visible: Summary">Our lawyers provide
													legal updates and practical insights on the latest Labor and
													Employment issues affecting US and multinational employers.</div>
											</div>
										</div>
									</div>
								</a>
							</div>

							<div class="featured-insights__tile promo-content-tile promo-content-tile--no-image">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="pcm-standard-background-image" style="background: url(&quot;&quot;) 0% 0% / cover no-repeat; display: none;">
										</div>
										<div class="container-row">
											<div class="content">
												<div class="content-type-label"
													data-bind="visible: TypeLabel, html: TypeLabel">Insight | Legal
													Update</div>
												<div class="content-headline" data-bind="html: Title, visible: Title">
													Canadian Labour and Employment Law</div>
												<div class="content-summary"
													data-bind="html: Summary, visible: Summary">Our lawyers provide
													legal updates and practical insights on the latest Labor and
													Employment issues affecting Canadian and multinational employers.
												</div>
											</div>
										</div>
									</div>
								</a>
							</div>

							<div class="featured-insights__tile promo-content-tile promo-content-tile--no-image">
								<a class="promo-content-link">
									<div class="container-table">
										<div class="pcm-standard-background-image" style="background: url(&quot;&quot;) 0% 0% / cover no-repeat; display: none;">
										</div>
										<div class="container-row">
											<div class="content">
												<div class="content-type-label"
													data-bind="visible: TypeLabel, html: TypeLabel">Insight | Recorded
													Webinar</div>
												<div class="content-headline" data-bind="html: Title, visible: Title">In
													Focus: Quick Chats for the Canadian Workplace</div>
												<div class="content-summary"
													data-bind="html: Summary, visible: Summary">Watch our video chat
													series where lawyers provide insights and quick, practical tips on
													today's most pressing issues and legal developments.</div>
											</div>
										</div>
									</div>
								</a>
							</div>
						</div>
					</div>
					<!-- /ko -->
					<!-- ko if: IsListView() == true -->
					<!-- /ko -->
					<!-- ko if: IsSearchRunning() != true && GridData().length == 0 -->
					<!-- /ko -->
				</div>
			</div>
		</div>
		<div class="global-footer">
			<div class="communication-footer hide-print">
				<ul class="social-links">
					<li class="social-link"><a class="iconfont icon-tuite" target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-f" target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-weibiaoti1"target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-weixin"target="_blank"></a></li>
					<li class="social-link"><a class="iconfont icon-wifi"target="_blank"></a></li>
				</ul>
			</div>
			<div class="footer-nav hide-print">
				<ul class="utility-links">
					<li class="utility-link"><a >Disclaimers</a></li>
					<li class="utility-link"><a >Privacy &amp; Cookies Statement</a></li>
					<li class="utility-link"><a class="ot-sdk-show-settings" title="Manage Choices">Cookie
							Preferences</a></li>
					<li class="utility-link"><a>CCPA Privacy Disclosures</a></li>
					<li class="utility-link"><a>Contact Us</a></li>
					<li class="utility-link"><a>Media Contacts</a></li>
					<li class="utility-link"><a>Blogs</a></li>
					<li class="utility-link"><a>BM Online</a></li>
				</ul>
		
			</div>
			<div class="copyright">
				<p><span>Attorney Advertising | © 2024 Baker McKenzie</span></p>
			</div>
		</div>
	</div>
</template>

<script>
	import Header from '../../components/header.vue'
	export default {
		components: {
			Header
		},
		data() {
			return {
				headerMini: false,
				thresholdHeight: 100,
				topicBgList: [
					require('../../assets/test/53.jpeg'),
					require('../../assets/test/51.webp'),
					require('../../assets/test/ft1.jpeg'),
					require('../../assets/test/52.webp')
				],
				toppicIndex: 0,
			}
		},
		mounted() {
			window.addEventListener('scroll', this.checkScrollPosition);
		},
		beforeDestroy() {
			// 在组件销毁前移除滚动监听
			window.removeEventListener('scroll', this.checkScrollPosition);
		},
		methods: {
			checkScrollPosition() {
				this.headerMini = window.scrollY >= this.thresholdHeight;
			},
			changeTopicBg(e) {
				this.toppicIndex = e
			},
			goHome() {
				this.$router.replace('/');
			},
		}
	}
</script>

<style lang='scss' scoped>
	.body-container {
		/* min-width: 1280px; */
		width: 100%;
		min-height: 100vh;
		overflow: hidden;
		position: relative;
		background-color: #fff;
	}
	.main {
		padding-top: 82px;
	}
	.page-header-options {
	    background: linear-gradient(287.72deg, #ad122a -2.45%, #790123 185.33%);
	    padding: 0.375em 0;
	    text-align: right;
	}
	.page-header-options .page-header-breadcrumb {
	    padding-right: 1.5em;
	    padding-left: 1.5em;
	    margin-left: auto;
	    margin-right: auto;
		height: 25px;
	}
	.breadcrumb-nav {
	    padding: 0.375em 0;
	}
	.page-header-options .breadcrumb-nav {
	    float: left;
	    text-align: left;
	    padding: 0;
	}
	.breadcrumb-nav .nav-links {
	    list-style-type: none;
	    white-space: nowrap;
	    overflow: hidden;
	    display: block;
	    text-overflow: ellipsis;
		margin: 0;
		padding: 0;
	}
	.breadcrumb-nav .nav-link {
	    display: inline;
	    color: #FFF;
	    font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
	    font-weight: normal;
	    font-style: normal;
	    font-size: 0.875em;
		letter-spacing: 1px;
		
		.icon-shouye {
			color: #fff;
			font-size: 15px;
			cursor: pointer;
		}
		
		.icon-xiangyou1 {
			font-size: 13px;
			margin: 0 5px;
		}
	}
	a {
	    color: #ad122a;
	    transition: color 0.4s, background-color 0.4s;
	}
	.breadcrumb-nav .nav-link a {
	    color: inherit;
	}
	.breadcrumb-nav .nav-link:first-of-type a {
	    font-size: 0;
	}
	.topic-selector {
		width: 100%;
		height: auto;
		overflow: hidden;
		position: relative;
		/* background-image: url('../../assets/test/ft-big-deal.webp'); */
		background-repeat: no-repeat;
		background-size: 100% 100%;
	
		.topic-selector__background {
			width: 100%;
			height: 100%;
			position: absolute;
			top: 0;
			background-color: #000;
			opacity: .6;
		}
	
		.topic-selector__tiles--four-grid {
			display: flex;
			flex-wrap: wrap;
			position: relative;
			z-index: 1;
	
			.topic-selector__header {
				min-height: 398px;
				width: calc(50% - 2px);
				border: none;
				border-bottom: 1px solid #FFF;
				display: flex;
				align-items: flex-end;
				position: relative;
				color: #fff;
				overflow: hidden;
				font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
				font-size: 48px;
	
				font-weight: bold;
	
				.topic-selector__tile {
					line-height: 140px;
					text-indent: 40px;
				}
	
				.topic-selector__title {
					font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
					font-weight: normal;
					font-style: normal;
					font-size: 24px;
					font-weight: 500;
					padding-right: 40px;
					line-height: 1.5;
					margin-bottom: 40px;
				}
			}
	
			.topic-card-inner {
				cursor: pointer;
			}
	
			.topic-selector__header:nth-child(n+2) {
				justify-content: flex-end;
			}
	
			.topic-selector__header:nth-child(even) {
				border-left: 1px solid #FFF;
			}
	
			.topic-selector__card {
				color: #FFF;
				background-color: #ad122a;
				position: absolute;
				top: 100%;
				left: 0;
				width: 100%;
				min-height: 100%;
				transition: top 0.4s ease-in-out;
				display: -ms-flexbox;
				display: flex;
				-ms-flex-direction: column;
				flex-direction: column;
				-ms-flex-pack: center;
				justify-content: center;
				font-size: 18px;
				text-indent: 0;
	
				.topic-selector__card-inner {
					padding: 2.1875rem;
	
					.topic-selector__card-title {
						font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
						font-weight: normal;
						font-style: normal;
						font-size: 48px;
						line-height: 1.1666;
						font-weight: bold;
					}
	
					.topic-selector__card-content {
						margin: 1em 0 3.5em;
						line-height: 1.5;
					}
	
					.topic-selector__card-link {
						color: #FFF;
						line-height: 1.5;
	
						.link--bold-white {
							color: #FFF;
							font-weight: bold;
							text-transform: uppercase;
							font-size: 14px;
							margin-right: 0;
							line-height: 1.5;
							transition: padding 0.4s ease-in-out, margin 0.4s ease-in-out;
						}
					}
				}
			}
	
			.topic-selector__header:hover {
	
				.topic-selector__card {
					top: 0;
				}
	
			}
		}
	}
	.global-module {
	    padding-top: 3.75em;
	    padding-bottom: 3.75em;
	    background: none;
	}
	.featured-insights.global-module {
	    padding-top: 0;
	    padding-bottom: 0;
	}
	.featured-insights {
	    max-width: 79.875em;
	    padding-right: 1.5em;
	    padding-left: 1.5em;
	    margin-left: auto;
	    margin-right: auto;
	    padding-right: 0;
	}
	.featured-insights.global-module .global-module-wrapper {
	    padding-left: 0;
	    padding-right: 0;
	    width: 100%;
	}
	.global-module .section-header-wrapper {
	    padding-bottom: 2.8125em;
	}
	.global-module .section-header-wrapper .section-header {
	    text-align: center;
	}
	h2, .h2 {
	    font-size: 32px;
	}
	.featured-insights__collection {
	    display: -ms-flexbox;
	    display: flex;
	    -ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	}
	.featured-insights__tile {
	    width: 30.75%;
	    margin-right: 3%;
	    margin-bottom: 30px;
	}
	.promo-content-tile {
	    position: relative;
	    background-color: #FFF;
	}
	.promo-content-tile .promo-content-link__intro {
	    font-size: 1.125em;
		letter-spacing: 1px;
	}
	.promo-content-tile .promo-content-link {
	    display: block;
	    height: 100%;
	}
	.promo-content-tile.promo-content-tile--has-image .promo-content-link {
	    height: calc(100% + 50px);
	}
	.promo-content-tile .container-table {
	    position: relative;
	    width: 100%;
	    height: calc(100% - 50px);
	    margin-bottom: 50px;
	    background-color: #FFF;
	}
	.promo-content-tile .container-row:after {
	    content: "";
	    position: absolute;
	    top: 0;
	    left: 0;
	    width: 100%;
	    height: 3px;
	    background-color: #ad122a;
	    transition: height 0.4s ease-in-out;
	}
	.pcm-standard-background-image {
	    position: relative;
	    cursor: pointer;
	    padding-bottom: 1.25em;
	}
	.promo-content-tile .promo-content-link .pcm-standard-background-image {
	    padding-bottom: 0;
	    padding-top: 100%;
	}
	.promo-content-tile .container-row {
	    background-color: #FFF;
	    padding: 30px 20px;
	    border: 1px solid #D2D2D2;
	    height: 100%;
	    min-height: 300px;
	}
	.promo-content-tile .content {
	    display: -ms-flexbox;
	    display: flex;
	    -ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	    position: relative;
	    overflow: hidden;
	    vertical-align: middle;
	    width: 100%;
	    z-index: 1;
	}
	.promo-content-tile .promo-content-link .content-meta-header {
	    width: 100%;
	}
	.promo-content-tile .promo-content-link .content-type-label, .promo-content-tile .promo-content-link .content-meta-header, .promo-content-tile .promo-content-link .content-headline {
	    transition: color .3s ease-in-out;
	    width: 100%;
	}
	.promo-content-tile .content .content-meta-header {
	    display: -ms-flexbox;
	    display: flex;
	}
	.promo-content-tile .promo-content-link .container-row {
	    display: -ms-flexbox;
	    display: flex;
	}
	.promo-content-tile .content-summary {
	    font-size: 18px;
	    color: #323232;
	    line-height: 1.5;
	    margin-top: 1.5em;
	    display: block;
	    transition: color .3s ease-in-out;
	}
	.featured-insights__tile:nth-child(3n) {
	    margin-right: 0;
	}
	.promo-content-category-switcher {
	    width: 100%;
	    margin-top: 3.125em;
	    margin-bottom: 3.125em;
	    text-align: center;
	}
	.promo-content-category-switcher .cat-option-left, .promo-content-category-switcher .cat-option-right {
	    position: relative;
	    display: inline-block;
	    height: 3em;
	    line-height: 1.875em;
	    background-color: #FDFDFD;
	    border: 1px solid #cececd;
	    color: #ad122a;
	    text-align: center;
	    text-transform: uppercase;
	    width: 9.5625em;
	    max-width: 40%;
	    padding: .5em 1em;
	    font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
	    font-weight: normal;
	    font-style: normal;
	    font-weight: bold;
	}
	.c-switch {
		height: 35px !important;
		line-height: 35px !important;
	}
	
	.promo-content-tile.promo-content-tile--has-image .container-row {
	    margin: 0 30px;
	    position: absolute;
	    bottom: 50px;
	    border: none;
	    height: auto;
	    min-height: 0;
	}
	.promo-content-tile.promo-content-tile--has-image .content-summary {
	    margin-top: 0;
	    max-height: 0;
	    color: #FFF;
	    margin-top: 0;
	    opacity: 0;
	    transition: max-height 0.4s ease-in-out, margin 0.4s ease-in-out, opacity 0.6s ease-in-out;
	}
	.promo-content-tile--has-image:hover {
		.content-summary {
			max-height: unset;
			opacity: 1;
			margin-top: 15px;
			letter-spacing: 1px;
		}
		.container-row  {
			background-color: #ad122a;
			animation: example1 0.8s ;
		}
		.content-headline {
			color: #fff;
		}
		.content-meta-header,.content-type-label,.content-summary {
			color: #fff !important;
		}
		
		@keyframes example1 {
			from {
				height: auto;
			}
			
			to {
				height: auto;
				/* 或者你想要的任何长度 */
			}
		}
	}
	.promo-content-tile--no-image:hover {
		.content-summary {
			max-height: unset;
			opacity: 1;
			margin-top: 15px;
			letter-spacing: 1px;
		}
		.container-row  {
			background-color: #ad122a;
			animation: example2 0.8s ;
			height: 100%;
		}
		.content-headline {
			color: #fff;
		}
		.content-meta-header,.content-type-label,.content-summary {
			color: #fff !important;
		}
		
		@keyframes example2 {
			from {
				height: 0%;
			}
			
			to {
				height: 100%;
				/* 或者你想要的任何长度 */
			}
		}
	}
	.promo-content-tile.promo-content-tile--has-image .container-table {
	    margin-bottom: 50px;
	    height: 100%;
	}
	.promo-content-tile .content .content-meta-header, .promo-content-tile .content .content-type-label {
	    font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
	    font-weight: normal;
	    font-style: normal;
	    color: #646464;
	    margin-bottom: 0.9375em;
	}
	.promo-content-tile .content .content-meta-header .content-type-label {
	    margin-bottom: 0;
	    width: 100%;
	}
	.promo-content-tile .content .content-meta-header .content-type-label--with-right {
	    display: inline-block;
	    width: 70%;
	    margin-right: 5px;
	}
	.promo-content-tile .content .content-meta-header .content-meta-header__right {
	    width: 30%;
	    text-align: right;
	    display: inline-block;
	}
	.bm, .promo-content-tile .content .external-link-icon:before {
	    display: inline-block;
	    font-family: "bakermckenzie";
	    font-style: normal;
	    font-weight: normal;
	    font-variant: normal;
	    font-size: inherit;
	    speak: none;
	    line-height: 1;
	    text-transform: none !important;
	    -webkit-font-smoothing: antialiased;
	    -moz-osx-font-smoothing: grayscale;
	    vertical-align: -6.14286%;
	}
	.promo-content-tile .content-headline {
	    font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
	    font-weight: normal;
	    font-style: normal;
	    font-weight: bold;
	    line-height: 1;
	    color: #D2D2D2;
	    font-size: 1.5em;
	    color: #323232;
	    word-wrap: break-word;
	    max-width: 333px;
	    line-height: 1.25;
	}
	.promo-content-tile .content .content-meta-header .bm-external-link {
	    margin-left: 5px;
	}
	.promo-content-category-switcher .selected {
	    background-color: #ad122a;
	    color: #FDFDFD;
	    border-color: transparent;
	}
	.featured-insights {
	    max-width: 79.875em;
	    padding-right: 1.5em;
	    padding-left: 1.5em;
	    margin-left: auto;
	    margin-right: auto;
	    padding-right: 0;
	}
	.button-red, #close-video {
	    text-transform: uppercase;
	    transition: background-color 0.4s;
	    color: #FFF;
	    padding: 1em 2em;
	    background-color: #ad122a;
	    line-height: 1em;
	    display: inline-block;
	    font-family: "BakerMcKenzieBernini", Arial Narrow, Arial;
	    font-weight: normal;
	    font-style: normal;
	    font-weight: bold;
		font-size: 16px;
	}
	button {
	    background: none;
	    border: none;
	}
	.c-bg1 {
		background: url('../../assets/test/54.webp');
		background-size: cover;
	}
	.c-bg2 {
		background: url('../../assets/test/55.webp');
		background-size: cover;
	}
	.c-bg3 {
		background: url('../../assets/test/56.webp');
		background-size: cover;
	}
	.c-bg4 {
		background: url('../../assets/test/57.webp');
		background-size: cover;
	}
	.c-bg5 {
		background: url('../../assets/test/51.webp');
		background-size: cover;
	}
	.c-bg6 {
		background: url('../../assets/test/52.webp');
		background-size: cover;
	}
	.c-bg7 {
		background: url('../../assets/test/54.webp');
		background-size: cover;
	}
	.c-bg8 {
		background: url('../../assets/test/55.webp');
		background-size: cover;
	}
	.global-footer, .global-footer-social {
	    font-family: "BakerMcKenzieBerniniCondensed", Arial Narrow, Arial;
	    font-weight: normal;
	    font-style: normal;
	    background: linear-gradient(108.99deg, #ad122a -0.16%, #790123 153.62%);
	    padding-top: 4.375em;
	    padding-bottom: 3.125em;
		
		.communication-footer {
		    text-align: center;
			
			.social-links {
			    display: inline-block;
				
				.social-link {
				    display: inline-block;
				    margin-left: 1rem;
				    margin-right: 1rem;
				    vertical-align: middle;
				    font-size: 1.75em;
					
					a {
					    color: #FFF;
						vertical-align: -6.14286%;
						line-height: 1;
					}
					.iconfont {
						font-size: 32px;
					}
				}
			}
		}
		.footer-nav{
		    margin-left: 1.5em;
		    margin-right: 1.5em;
			border-top: 1px solid #cececd;
			max-width: 79.875em;
			padding: 1.5em 0 0;
			
			.utility-links{
			    font-size: 1.125em;
				display: flex;
				justify-content: space-between;
				
				.utility-link {
				    color: #FFF;
					display: inline-block;
					padding-right: 1em;
					
					a {
					    color: #FFF;
					}
				}
			}
		}
		.copyright {
			margin-left: 1.5em;
			margin-top: 1.5em;
			color: #FFF;
			max-width: 79.875em;
			margin-right: 1.5em;
			padding: 0;
			text-align: center;
		}
	}
	@media screen and (max-width: 61.9375em){
		.featured-insights__collection {
		    display: block !important;
		}
		.featured-insights__tile {
		    width: 100% !important;
		    margin-right: 0;
		    padding: 0 10px;
		}
		.featured-insights {
			max-width: 54.9375em;
			padding-right: 2em;
			padding-left: 2em;
			margin-left: auto;
			margin-right: auto;
		}
		.promo-content-tile.promo-content-tile--has-image .promo-content-link .container-row {
		    margin: 0 20px;
		    padding: 15px;
		    bottom: -50px;
		    width: calc(89% - 40px);
		}
		.promo-content-category-switcher .cat-option-left[data-v-782a4b1e], .promo-content-category-switcher .cat-option-right {
			width: 6.5625em !important;
			font-size: 14px;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .footer-nav .utility-links, .global-footer-social .footer-nav .utility-links {
		    display: -ms-flexbox;
		    display: flex;
		    -ms-flex-direction: row;
		    flex-direction: row;
		    -ms-flex-wrap: wrap;
		    flex-wrap: wrap;
		    text-align: left;
		    padding: 0;
		    -ms-flex-align: center;
		    align-items: center;
		}
		.global-footer .footer-nav .utility-links .utility-link, .global-footer-social .footer-nav .utility-links .utility-link {
		    width: 35%;
		    padding-bottom: 1em;
		    padding-right: 0;
		    padding-left: 20px;
		    min-height: 40px;
		}
		.global-footer .copyright, .global-footer-social .copyright {
		    display: block;
		    text-align: center;
		}
		.global-footer .footer-nav, .global-footer .copyright, .global-footer-social .footer-nav, .global-footer-social .copyright {
		    margin-left: 1.5em;
		    margin-right: 1.5em;
		}
		.global-footer .communication-footer .social-links .social-link .iconfont[data-v-782a4b1e], .global-footer-social .communication-footer .social-links .social-link .iconfont {
			font-size: 23px;
		}
		.topic-selector .topic-selector__tiles--four-grid .topic-selector__header .topic-selector__title{
			padding-right: 0;
			padding-left: 20px;
			margin-bottom: 20px;
		}
		.topic-selector .topic-selector__tiles--four-grid .topic-selector__header {
			font-size: 25px;
			font-weight: unset;
		}
		.topic-selector .topic-selector__tiles--four-grid .topic-selector__header .topic-selector__tile {
			line-height: 30px;
			text-indent: 0;
			padding-left: 20px;
			margin-bottom: 20px;
		}
		.main {
			padding-top: 63px;
		}
		.topic-selector .topic-selector__tiles--four-grid .topic-selector__card {
			display: none;
		}
	}
</style>